module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive-selected/bft-13d44a1b93ada3d5430e74b716efa262.png";